// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-financeDash {
  width: 95%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-row-gap: 5px;
}

.panel {
  padding: 1px 5px 6px;
}

@media (max-width: 768px) {
  .parent-financeDash {
    display: block;
  }

  .panel {
    margin-bottom: 15px;
  }
}

.div5-financeDash {
  grid-area: 5 / 1 / 5 / 6;
}
.div6-financeDash {
  grid-area: 6 / 1 / 6 / 4;
}
.div7-financeDash {
  grid-area: 6 / 4 / 6 / 6;
}
.div8-financeDash {
  grid-area: 7 / 1 / 7 / 6;
}
.div9-financeDash {
  grid-area: 8 / 1 / 8 / 6;
}
.div10-financeDash {
  grid-area: 9 / 1 / 9 / 3;
}
.div11-financeDash {
  grid-area: 9 / 3 / 9 / 6;
}
.div12-financeDash {
  grid-area: 10 / 1 / 11 / 6; 
}

/* Estilos cuadritos parte superior */
.div1-financeDash {
  grid-area: 1 / 1 / 2 / 2; /* Ocupa la primera columna */
}
.divE0-financDash{ grid-area: 1 / 2 / 2 / 3; }
.divE1-financDash{ grid-area: 1 / 3 / 2 / 4; }
.divE2-financDash{ grid-area: 1 / 4 / 2 / 5; }
.divE3-financDash{ grid-area: 1 / 5 / 2 / 6; }
.divE4-financDash{ grid-area: 1 / 6 / 2 / 7; }
.divE5-financDash{ grid-area: 2 / 1 / 3 / 2; }
.divE6-financDash{ grid-area: 2 / 2 / 3 / 3; }
.divE7-financDash{ grid-area: 2 / 3 / 3 / 4; }
.divE8-financDash{ grid-area: 2 / 4 / 3 / 5; }
.divE9-financDash{ grid-area: 2 / 5 / 3 / 6; }
.divE10-financDash { grid-area: 2 / 6 / 3 / 7; }
.divE11-financDash { grid-area: 3 / 1 / 4 / 2; }
.divE12-financDash { grid-area: 3 / 2 / 4 / 3; }
.divE13-financDash { grid-area: 3 / 3 / 4 / 4; }
.divE14-financDash { grid-area: 4 / 1 / 5 / 2; }
.divE15-financDash { grid-area: 4 / 2 / 5 / 3; }


.download-invoice {
  display: flex;
  justify-content: center;
}

.icon-download {
  cursor: pointer;
}

.sort-arrow {
  margin-left: 5px;
  cursor: pointer;
  color: rgb(116, 116, 116);
}

.titles {
  display: flex;
  justify-content: center;
}
.title {
  color: black;
}

.cont-donutsf {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex: 1 1;
  margin: 10px;
  text-align: center;
  max-width: 100%;
  max-height: 400px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/DashFinance/FinanceDashboard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,wBAAwB,EAAE,6BAA6B;AACzD;AACA,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,wBAAwB,EAAE;AAC7C,qBAAqB,wBAAwB,EAAE;AAC/C,qBAAqB,wBAAwB,EAAE;AAC/C,qBAAqB,wBAAwB,EAAE;AAC/C,qBAAqB,wBAAwB,EAAE;AAC/C,qBAAqB,wBAAwB,EAAE;AAC/C,qBAAqB,wBAAwB,EAAE;;;AAG/C;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".parent-financeDash {\n  width: 95%;\n  margin: auto;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-row-gap: 5px;\n}\n\n.panel {\n  padding: 1px 5px 6px;\n}\n\n@media (max-width: 768px) {\n  .parent-financeDash {\n    display: block;\n  }\n\n  .panel {\n    margin-bottom: 15px;\n  }\n}\n\n.div5-financeDash {\n  grid-area: 5 / 1 / 5 / 6;\n}\n.div6-financeDash {\n  grid-area: 6 / 1 / 6 / 4;\n}\n.div7-financeDash {\n  grid-area: 6 / 4 / 6 / 6;\n}\n.div8-financeDash {\n  grid-area: 7 / 1 / 7 / 6;\n}\n.div9-financeDash {\n  grid-area: 8 / 1 / 8 / 6;\n}\n.div10-financeDash {\n  grid-area: 9 / 1 / 9 / 3;\n}\n.div11-financeDash {\n  grid-area: 9 / 3 / 9 / 6;\n}\n.div12-financeDash {\n  grid-area: 10 / 1 / 11 / 6; \n}\n\n/* Estilos cuadritos parte superior */\n.div1-financeDash {\n  grid-area: 1 / 1 / 2 / 2; /* Ocupa la primera columna */\n}\n.divE0-financDash{ grid-area: 1 / 2 / 2 / 3; }\n.divE1-financDash{ grid-area: 1 / 3 / 2 / 4; }\n.divE2-financDash{ grid-area: 1 / 4 / 2 / 5; }\n.divE3-financDash{ grid-area: 1 / 5 / 2 / 6; }\n.divE4-financDash{ grid-area: 1 / 6 / 2 / 7; }\n.divE5-financDash{ grid-area: 2 / 1 / 3 / 2; }\n.divE6-financDash{ grid-area: 2 / 2 / 3 / 3; }\n.divE7-financDash{ grid-area: 2 / 3 / 3 / 4; }\n.divE8-financDash{ grid-area: 2 / 4 / 3 / 5; }\n.divE9-financDash{ grid-area: 2 / 5 / 3 / 6; }\n.divE10-financDash { grid-area: 2 / 6 / 3 / 7; }\n.divE11-financDash { grid-area: 3 / 1 / 4 / 2; }\n.divE12-financDash { grid-area: 3 / 2 / 4 / 3; }\n.divE13-financDash { grid-area: 3 / 3 / 4 / 4; }\n.divE14-financDash { grid-area: 4 / 1 / 5 / 2; }\n.divE15-financDash { grid-area: 4 / 2 / 5 / 3; }\n\n\n.download-invoice {\n  display: flex;\n  justify-content: center;\n}\n\n.icon-download {\n  cursor: pointer;\n}\n\n.sort-arrow {\n  margin-left: 5px;\n  cursor: pointer;\n  color: rgb(116, 116, 116);\n}\n\n.titles {\n  display: flex;\n  justify-content: center;\n}\n.title {\n  color: black;\n}\n\n.cont-donutsf {\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-start;\n  flex: 1;\n  margin: 10px;\n  text-align: center;\n  max-width: 100%;\n  max-height: 400px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
